import * as React from "react";
import { NomenclatureAutocompleteFilter } from "@duosoftbg/nacid-components";
import useAppSelector from "../../../../../../../hooks/redux/base/useAppSelector";
import { useStore } from "react-redux";
import { eduLevelsThunk } from "../../../../../../../store/redux/slice/AppData/eduLevels";
import { RootState } from "../../../../../../../store/redux/store";

const EduLevelFilter = ({ label = "l.searchFilter.eduLevel", xs = 12, sm = 6, md = 6, group }) => {
  const store = useStore();
  const thunkState = useAppSelector((state) => {
    return state.AppData.eduLevels;
  });

  const getPreviousStateOptionFn = () => {
    const state = store.getState() as RootState;
    const eduLevel = state.SearchData.searchTable[group].filtersData.eduLevel;
    const options = state.AppData.eduLevels.data;
    return options.find((element) => element.id === eduLevel);
  };

  return (
    <NomenclatureAutocompleteFilter
      label={label}
      filter={"eduLevel"}
      thunkFn={eduLevelsThunk}
      thunkState={thunkState}
      getPreviousStateOptionFn={getPreviousStateOptionFn}
      xs={xs}
      sm={sm}
      md={md}
    />
  );
};

export default EduLevelFilter;
